import React, { useState } from "react";
import { MDBIcon, MDBTableHead } from "mdbreact";
import { Th } from "./styled";
import { renderCells, TABLE_HEADERS } from "./config";
const renderCell = (condition, content) => {
  return condition ? <td>{content}</td> : null;
};

const CommonTableRow = ({
  row,
  tableConfig,
  choosedSiteId,
  handleRowClick,
  level,
  isExpanded,
  setHidedRows,
  hidedRows,
  grouping,
  index,
  onSort,
  sortConfig
}) => {
  const levelConfig = {
    1: "#00bcd4",
    2: "#454545",
    3: "rgb(125, 122, 122)",
  };

  if (hidedRows.includes(row.grouping)) {
    return null;
  }
  const isExpandVisible = () => {
    if (level === 2 && grouping.third) {
      return true;
    }
    if (level === 1 && grouping.second) {
      return true;
    }
    return false;
  };
  const getFirstColumnName = () => {
    if (level === 1) {
      return grouping.first;
    }
    if (level === 2) {
      return grouping.second;
    }
    if (level === 3) {
      return grouping.third;
    }
    return "Grouping";
  };

  const getSortableKey = (id) => {
    const mapping = {
      'registrations': 'registration',
      'fillProfiles': 'fillProfile',
      'emailConfirmed': 'emailConfirmed',
      'posted': 'posted',
      'sms4Plus35': 'sms4Plus35',
      'online': 'online',
      'sales': 'sales',
      'ftd': 'ftd',
      'turnover': 'turnover',
      'investment': 'investment',
      'profit': 'profit',
      'roi': 'roi'
    };
    return mapping[id];
  };
  return (
    <>
      {index === 0 ? (
        <tr style={{ backgroundColor: levelConfig[level], color: "white" }}>
          <td key="grouping" style={{ textTransform: "capitalize" }}>
            {getFirstColumnName()}
          </td>
          {TABLE_HEADERS.map(({ header, id, siteIds }) => {
            if (!siteIds || siteIds.includes(choosedSiteId)) {
              if (tableConfig.includes(id)) return null;
              return (
                <Th
                  direction={sortConfig.direction}
                  isSorting={sortConfig.key === getSortableKey(id)}
                  onClick={() => onSort(getSortableKey(id))}
                  key={id}
                >
                  {header}
                </Th>
              );
            }
            return null;
          })}
          <td key="actions"></td>
        </tr>
      ) : null}
      <tr
        style={{
          backgroundColor: level !== 1 ? "rgba(0, 0, 0, 0.2)" : "white",
        }}
      >
        <td style={{ paddingLeft: `${level * 10}px` }}>
          {isExpandVisible() && (
            <MDBIcon
              icon={isExpanded ? "angle-up" : "angle-down"}
              color="black"
              size="lg"
              style={{ marginRight: 10, cursor: "pointer" }}
              onClick={handleRowClick}
            />
          )}
          {row.grouping}
        </td>
        {renderCells(row, tableConfig, choosedSiteId).map((cell, index) =>
          renderCell(cell.condition, cell.content)
        )}
        <td>
          <MDBIcon
            icon="eye-slash"
            color="black"
            size="sm"
            style={{ cursor: "pointer" }}
            onClick={() => setHidedRows([...hidedRows, row.grouping])}
          />
        </td>
      </tr>
    </>
  );
};

export default CommonTableRow;
